import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Screen\GetScreenScreenshotDataByIdController::__invoke
* @see app/Http/Controllers/Screen/GetScreenScreenshotDataByIdController.php
* @route '/api/screen-settings/{screen}/screenshot'
*/
const GetScreenScreenshotDataByIdController = (args: { screen: string | number | { id: string | number } } | [screen: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetScreenScreenshotDataByIdController.url(args, options),
    method: 'get',
})

GetScreenScreenshotDataByIdController.definition = {
    methods: ["get","head"],
    url: '/api/screen-settings/{screen}/screenshot',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Screen\GetScreenScreenshotDataByIdController::__invoke
* @see app/Http/Controllers/Screen/GetScreenScreenshotDataByIdController.php
* @route '/api/screen-settings/{screen}/screenshot'
*/
GetScreenScreenshotDataByIdController.url = (args: { screen: string | number | { id: string | number } } | [screen: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { screen: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { screen: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            screen: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        screen: typeof args.screen === 'object'
        ? args.screen.id
        : args.screen,
    }

    return GetScreenScreenshotDataByIdController.definition.url
            .replace('{screen}', parsedArgs.screen.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Screen\GetScreenScreenshotDataByIdController::__invoke
* @see app/Http/Controllers/Screen/GetScreenScreenshotDataByIdController.php
* @route '/api/screen-settings/{screen}/screenshot'
*/
GetScreenScreenshotDataByIdController.get = (args: { screen: string | number | { id: string | number } } | [screen: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetScreenScreenshotDataByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Screen\GetScreenScreenshotDataByIdController::__invoke
* @see app/Http/Controllers/Screen/GetScreenScreenshotDataByIdController.php
* @route '/api/screen-settings/{screen}/screenshot'
*/
GetScreenScreenshotDataByIdController.head = (args: { screen: string | number | { id: string | number } } | [screen: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetScreenScreenshotDataByIdController.url(args, options),
    method: 'head',
})

export default GetScreenScreenshotDataByIdController